// src/utils/createVariableMap.ts
var createVariableMap = (scheme, prefix) => {
  const vars = {};
  const processCategory = (category, value, path = [], target = vars) => {
    if (typeof value === "string") {
      const varName = [prefix, category, ...path].join("-");
      const lastKey = path[path.length - 1];
      target[lastKey] = `var(--${varName})`;
    } else {
      const currentPath = path[path.length - 1];
      if (currentPath) {
        target[currentPath] = target[currentPath] || {};
      }
      Object.entries(value).forEach(([key, subValue]) => {
        processCategory(
          category,
          subValue,
          [...path, key],
          currentPath ? target[currentPath] : target
        );
      });
    }
  };
  Object.entries(scheme).forEach(([category, value]) => {
    vars[category] = {};
    processCategory(category, value, [], vars[category]);
  });
  return vars;
};

export {
  createVariableMap
};
